<template lang="html">
	<v-footer dark app fixed class="footer"></v-footer>
</template>

<script lang="js">
	export default {
		name: 'AppFooter'
	};
</script>
